// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SbOqnEdfg8glts {
  display: flex;
  align-items: center;
  gap: var(--ds-space-100, 8px);
  margin: var(--ds-space-200, 16px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
  color: var(--dynamic-text);
  font-weight: var(--ds-font-weight-medium, 500);
}
`, ""]);
// Exports
export var header = `SbOqnEdfg8glts`;
export default ___CSS_LOADER_EXPORT___;
